import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import Vuelidate from 'vuelidate';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import '@/assets/scss/theme.scss'


Vue.config.productionTip = false
Vue.config.devtools = true;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
